import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, ApiVisa } from '../../shared';
import { ApiResponseModel } from '../../shared/api-response.model';
import { AgingPeriodContainerModel } from '../../../../../../models/aggregates/erp/aging-period/aging-period-container.model';

@Injectable({
  providedIn: 'root'
})
export class AgingPeriodService extends BaseApiTemplateService<AgingPeriodContainerModel> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/aging-periods/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/aging-periods/backoffice-ep";
        this.httpClient = http;
      }
}
